import { Component } from "@angular/core";

@Component({
  selector: "changelogViewComponent",
  templateUrl: "./view.html",
})
export class ChangelogViewComponent { }
